
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_4eja5_97",
  "tools": "awsui_tools_wih1l_4eja5_108",
  "tools-filtering": "awsui_tools-filtering_wih1l_4eja5_114",
  "tools-align-right": "awsui_tools-align-right_wih1l_4eja5_128",
  "tools-pagination": "awsui_tools-pagination_wih1l_4eja5_132",
  "tools-preferences": "awsui_tools-preferences_wih1l_4eja5_132",
  "tools-small": "awsui_tools-small_wih1l_4eja5_138",
  "table": "awsui_table_wih1l_4eja5_144",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_4eja5_150",
  "wrapper": "awsui_wrapper_wih1l_4eja5_154",
  "variant-stacked": "awsui_variant-stacked_wih1l_4eja5_163",
  "variant-container": "awsui_variant-container_wih1l_4eja5_163",
  "variant-embedded": "awsui_variant-embedded_wih1l_4eja5_167",
  "variant-borderless": "awsui_variant-borderless_wih1l_4eja5_167",
  "has-header": "awsui_has-header_wih1l_4eja5_170",
  "has-footer": "awsui_has-footer_wih1l_4eja5_173",
  "cell-merged": "awsui_cell-merged_wih1l_4eja5_190",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_4eja5_201",
  "empty": "awsui_empty_wih1l_4eja5_216",
  "loading": "awsui_loading_wih1l_4eja5_220",
  "selection-control": "awsui_selection-control_wih1l_4eja5_229",
  "selection-control-header": "awsui_selection-control-header_wih1l_4eja5_236",
  "sticky-scrollbar": "awsui_sticky-scrollbar_wih1l_4eja5_241",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_wih1l_4eja5_250",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_wih1l_4eja5_253",
  "sticky-scrollbar-native-invisible": "awsui_sticky-scrollbar-native-invisible_wih1l_4eja5_256",
  "dark-header": "awsui_dark-header_wih1l_4eja5_264",
  "header-secondary": "awsui_header-secondary_wih1l_4eja5_269",
  "table-has-header": "awsui_table-has-header_wih1l_4eja5_285",
  "header-controls": "awsui_header-controls_wih1l_4eja5_289",
  "variant-full-page": "awsui_variant-full-page_wih1l_4eja5_293",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_4eja5_306",
  "footer": "awsui_footer_wih1l_4eja5_306",
  "thead-active": "awsui_thead-active_wih1l_4eja5_315",
  "row": "awsui_row_wih1l_4eja5_316",
  "row-selected": "awsui_row-selected_wih1l_4eja5_317"
};
  